import {RootState} from '../../store';

const key = 'certificates';

// FNP-1300 — the selection slice, keyed by certificate id.
export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};
